/*
 * Copyright 2020-2026 Bloomreach
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { ContainerModule } from 'inversify';
import { ApiImpl, ApiService } from './api';
import { SpaService, Spa } from './spa';

export function SpaModule(): ContainerModule {
  return new ContainerModule((bind) => {
    bind(ApiService).to(ApiImpl).inSingletonScope();
    bind(SpaService).to(Spa).inSingletonScope();
  });
}

export { ApiOptionsToken, ApiOptions, ApiService, Api } from './api';
export { SpaService, Spa } from './spa';
